import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {ApiService} from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  public isProductUpdate$: Subject<boolean> = new Subject<boolean>();
  product: any;

  constructor(
    private readonly api: ApiService
  ) {
  }

  async get(id: string) {
    this.product = await this.api.entProduct.get(id).then();
    return this.product;
  }
}
